import { useTranslation } from '@yme/services/i18n';
export const useProductPricingInfoLabels = () => {
    const { t } = useTranslation();
    return {
        productSize: t('product_size_label'),
        rotation: t('productPricingInfo_tableRotation_label'),
        shaftLength: t('productPricingInfo_tableShaftLength_label'),
        startingMethod: t('productPricingInfo_tableStartingMethod_label'),
        controlMethod: t('productPricingInfo_tableControlMethod_label'),
        powerVersion: t('productCard_powerVersion_label'),
        transmission: t('productCard_transmission_label'),
        loweredVersion: t('productCard_loweredVersion_label'),
        length: t('productCard_length_label'),
        productOption: t('productCard_version_label'),
        price: t('productPricingInfo_tablePrice_label'),
        frameSizeSmall: t('product_frameSizeSmall_label'),
        frameSizeMedium: t('product_frameSizeMedium_label'),
        frameSizeLarge: t('product_frameSizeLarge_label'),
    };
};
